import { CompanyConversationsHistory } from "./conversation-history";

/**
 * The history rail's body.
 *
 * There used to be two tabs — "Recent Chats" and "Queries" — over the same
 * conversations, one listing them and the other listing their prompts. That
 * made the user choose a view before they could look for anything, and hid
 * prompts behind a tab most never opened. One list now: conversations, each
 * expandable to reveal its prompts on demand.
 */
export const CompanyConversations = () => (
  <div className="flex h-full min-h-0 flex-col">
    <CompanyConversationsHistory />
  </div>
);
